/*
 * Rich Text Atom
 *
 */

import React from "react"
// import PropTypes from "prop-types"
import { renderRichText } from "gatsby-source-storyblok"
import parse from "html-react-parser"

const RichText = ({ text }) => {
  let richText = renderRichText(text)
  return <div className="rich-text">{parse(richText)}</div>
}

// RichText.defaultProps = {
// }

// RichText.propTypes = {
// }

export default RichText
